<div class="core-ui-flash-toast-host" [ngClass]="'is-' + position" *ngIf="config">
  <div
    class="core-ui-flash-toast"
    [ngClass]="['is-' + type, phaseClass]"
    role="status"
    aria-live="polite"
  >
    <span class="core-ui-flash-toast__icon">
      <core-ui-icon [name]="iconName" size="sm" color="currentColor"></core-ui-icon>
    </span>

    <span class="core-ui-flash-toast__message">{{ config.message }}</span>
  </div>
</div>
